import { Link } from "react-router-dom";

import Carousel from "react-bootstrap/Carousel";
const images = [
  {
    title: "Good Boys Go To Heaven",
    image:
      "https://s3-ap-southeast-1.amazonaws.com/ams-astro/production/images/KWGPI_series.jpg",
    detail: "/content/4d75e4e3-a648-4245-9a1a-63a4cc08e320",
  },
  {
    title: "Malam Terlarang",
    image:
      "https://s3-ap-southeast-1.amazonaws.com/ams-astro/production/images/KVFLH.jpg",
    detail: "/content/1660b736-20cb-4e0f-abba-d42e073a4ad3",
  },
  {
    title: "Dendam Seorang Mentua",
    image:
      "https://s3-ap-southeast-1.amazonaws.com/ams-astro/production/images/KWYYQ_series.jpg",
    detail: "/content/9291eb2c-9d9a-4329-be71-6c8b3fd90545",
  },
  {
    title: "The Exiled",
    image:
      "https://s3-ap-southeast-1.amazonaws.com/ams-astro/production/images/KUTXK_series.jpg",
    detail: "/content/5a77a40a-65b6-46c7-93c8-045fdb6a6f8f",
  },
  {
    title: "Manam",
    image:
      "https://s3-ap-southeast-1.amazonaws.com/ams-astro/production/images/KVBYU_series.jpg",
    detail: "/content/562d9dde-2b5f-4623-a11f-0b57c46e3235",
  },
];

function ContentSlider() {
  return (
    <Carousel className="slider-container">
      {images.map((slide) => (
        <Carousel.Item key={slide.title}>
          <img className="poster-image" src={slide.image} alt={slide.title} />
          <Link to={slide.detail}>
            <button className="poster-button">View Details</button>
          </Link>
          <Carousel.Caption>
            <h3>{slide.title}</h3>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default ContentSlider;
